import { SCREEN_TITLE } from '@shared/config';
import { NotFoundScreen } from '@widgets/not-found';

/**
 * S21 페이지 없음. Figma `2143:25089` — T1(BackBar 없음, DD-15 H19) 본문에 StatusScreen kind=not-found.
 * 권한 차이는 머리(GlobalHeader role)뿐이라 화면은 같다. 디자인 확인 탭에서는 탭 본문에 들어간다.
 * 화면 이름(h1)은 숨기고, 보이는 제목은 StatusScreen 의 h2 다.
 */
export function NotFoundPage() {
  return (
    <>
      <h1 className="sr-only">{SCREEN_TITLE.S21}</h1>
      <NotFoundScreen />
    </>
  );
}
